module.exports = __webpack_public_path__ + "static/media/transaction.dc4759c6.svg";